import { Fade, Grid } from "@mui/material"
import { PageTitle } from "../../layoutPages/components/PageTitle"
import { DefaultSetting } from "../../layoutPages/defaultSetting"
import { MyColorButton } from "../../layoutPages/components/MyColorButton"
import { ShortCut } from "../../system/ShortCut";
import { MainCard } from "../../layoutPages/components/MainCard";
import { Navigate, useNavigate } from "react-router-dom";
import { ParentMeetingTopButtons } from "./ParentMeetingTopButtons";

export function PageParentsMain() {
    return (
        <Fade in={true} timeout={2000}>
            <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
                <ParentMeetingTopButtons />
                <MainCard src="http://www.pkps.edu.hk/img/website/parentMeetingImg/front.jpg" sx={{ maxWidth: 800, m: 2 }} noImgPopup />
            </Grid>
        </Fade>
    )
}